import { Contract, ContractStatuses } from "../api/dtos";

const invalidContractStatuses : ContractStatuses[] = [
    ContractStatuses.ContractCancelled,
    ContractStatuses.ContractRecission,
    ContractStatuses.ContractForfeited,
]

export const isContractInvalid = (contract?: Contract | null) => {
    return !!contract?.status && invalidContractStatuses.includes(contract.status);
}

export const isContractStatusInvalid = (status?: ContractStatuses | number | null) => {
    return !!status && invalidContractStatuses.includes(status);
}